import { render, staticRenderFns } from "./ElementHeights.vue?vue&type=template&id=56604ba1&scoped=true&"
import script from "./ElementHeights.vue?vue&type=script&lang=js&"
export * from "./ElementHeights.vue?vue&type=script&lang=js&"
import style0 from "./ElementHeights.vue?vue&type=style&index=0&id=56604ba1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56604ba1",
  null
  
)

export default component.exports